export default function (context, val) {
    let form = context.state.form;
    context.dispatch('set_title', 'Редактирование требования №' + val.id, {root: true});
    context.commit('set_load', {
        data: false,
    });
    context.dispatch('regulars/get', {
        id: val.id,
        callback: (regular) => {
            context.state.system.manager = regular.data.Manager ? regular.data.Manager : '';
            context.state.system.PaySystemType = regular.data.PaySystemDocumentNumber ? regular.data.PaySystemType : '';
            context.state.system.createDate = regular.data.CreatedDate ? regular.data.CreatedDate.Serialized : '';
            context.commit('set_form', regular.form);
            context.state.options.legals = regular.legals;
            if (!regular.data.Invoices.length) return;
            regular.data.Invoices.forEach(i => {
                context.dispatch('invoices/get', {
                    id: i.RegularPaymentId,
                    noSetData: true,
                    callback: (invoice) => {
                        invoice.sum = i.Spread;
                    }
                });
            })
        }
    });
    context.dispatch('files/get', val.id);
}
